<p-dialog
    visible="true"
    [maximizable]="false"
    [modal]="true"
    appendTo="body"
    [closable]="false"
    [style]="{ 'min-width': '25em' }"
>
    <p-header>
        {{ config.header }}
        <span *ngIf="count && count > 0">({{ count }} selected)</span></p-header
    >
    <p-messages [value]="messages" styleClass="popup-alert"></p-messages>
    <form [formGroup]="bulkFormGroup">
        <h2>General Invoice</h2>
        <div style="display: flex; flex-direction: row; width: 100%">
            <span id="spnShowindirectrates" style="width: 15vw">
                <p-checkbox
                    id="Showindirectrates"
                    [formControl]="bulkFormGroup.controls['Showindirectrates']"
                    #holidayAuths
                    binary="true"
                    [indeterminate]="checkboxStates['Showindirectrates']?.indeterminate"
                    (onChange)="onCheckboxChange('Showindirectrates', $event)"
                ></p-checkbox>

                <a
                    style="z-index: 1; padding-left: 0.5rem"
                    title="Click for more information"
                    href="https://www.efaactcentral.com/eFAACTUserManual/index.htm?context=540#showIndirectRateGrid"
                    target="_blank"
                    >Show Indirect Rate Grid</a
                >
                <!-- <label style="margin-top: .05vh" id="tristatelabel" for="Showindirectrates">Show Indirect Rate Grid</label> -->
            </span>
            <!-- <a style="z-index: 1;" title="Click for more information" href="https://www.efaactcentral.com/eFAACTUserManual/index.htm?context=540#showIndirectRateGrid" target="_blank"><i class="pi pi-info-circle"></i></a> -->
        </div>

        <div
            style="
                display: flex;
                flex-direction: row;
                width: 100%;
                margin-bottom: 1vh;
                margin-top: 1vh;
            "
        >
            <p-floatLabel variant="on" class="w-full">
                <p-select
                    id="Accountclass"
                    [options]="accountClassProperties"
                    formControlName="Accountclass"
                    [filter]="true"
                    appendTo="body"
                    [autoDisplayFirst]="false"
                    styleClass="w-full"
                >
                </p-select>
                <label for="Accountclass">Account Classification</label>
            </p-floatLabel>
            <!-- <a style="z-index: 1; margin-top: .8vh; margin-left: .5vw;" title="Click for more information" href="https://www.efaactcentral.com/eFAACTUserManual/index.htm?context=540#accountClassification" target="_blank"><i class="pi pi-info-circle"></i></a> -->
        </div>

        <div
            style="
                display: flex;
                flex-direction: row;
                width: 100%;
                margin-bottom: 1vh;
            "
        >
            <p-floatLabel variant="on" class="w-full">
                <input
                    type="text"
                    id="Invprefix"
                    title="Invoice Prefix"
                    pInputText
                    formControlName="Invprefix"
                    class="w-full"
                />
                <label for="Invprefix">Invoice Prefix</label>
            </p-floatLabel>
            <!-- <a style="z-index: 1; margin-top: .8vh; margin-left: .5vw;" title="Click for more information" href="https://www.efaactcentral.com/eFAACTUserManual/index.htm?context=540#invoicePrefix" target="_blank"><i class="pi pi-info-circle"></i></a> -->
        </div>

        <h2>Invoice Summary</h2>
        <div
            style="
                display: flex;
                flex-direction: row;
                width: 100%;
                margin-bottom: 1vh;
            "
        >
            <span id="spnShowfundingbalance" style="width: 15vw">
                <p-checkbox
                    binary="true"
                    id="Showfundingbalance"
                    [formControl]="bulkFormGroup.controls['Showfundingbalance']"
                    [indeterminate]="checkboxStates['Showfundingbalance']?.indeterminate"
                    (onChange)="onCheckboxChange('Showfundingbalance', $event)"
                ></p-checkbox>
                <a
                    style="z-index: 1; padding-left: 0.5rem"
                    title="Click for more information"
                    href="https://www.efaactcentral.com/eFAACTUserManual/index.htm?context=540#showFundingAndBalance"
                    target="_blank"
                    >Show Funding and Balance</a
                >
                <!-- <label style="margin-top: .05vh" for="Showfundingbalance">Show Funding and Balance</label> -->
            </span>
            <!-- <a style="z-index: 1;" title="Click for more information" href="https://www.efaactcentral.com/eFAACTUserManual/index.htm?context=540#showFundingAndBalance" target="_blank"><i class="pi pi-info-circle"></i></a> -->
        </div>
        <div
            style="
                display: flex;
                flex-direction: row;
                width: 100%;
                margin-bottom: 1vh;
            "
        >
            <span id="spnShowcontractbalance" style="width: 15vw">
                <p-checkbox
                    binary="true"
                    id="Showcontractbalance"
                    [formControl]="
                        bulkFormGroup.controls['Showcontractbalance']
                    "
                    [indeterminate]="checkboxStates['Showcontractbalance']?.indeterminate"
                    (onChange)="onCheckboxChange('Showcontractbalance', $event)"
                ></p-checkbox>
                <a
                    style="z-index: 1; padding-left: 0.5rem"
                    title="Click for more information"
                    href="https://www.efaactcentral.com/eFAACTUserManual/index.htm?context=540#showContractBalance"
                    target="_blank"
                    >Show Contract Balance</a
                >
                <!-- <label style="margin-top: .05vh" for="Showcontractbalance">Show Contract Balance</label> -->
            </span>
            <!-- <a style="z-index: 1;" title="Click for more information" href="https://www.efaactcentral.com/eFAACTUserManual/index.htm?context=540#showContractBalance" target="_blank"><i class="pi pi-info-circle"></i></a> -->
        </div>
        <div
            style="
                display: flex;
                flex-direction: row;
                width: 100%;
                margin-bottom: 1vh;
            "
        >
            <span id="spnShowcosttypesummary" style="width: 17vw">
                <p-checkbox
                    binary="true"
                    id="Showcosttypesummary"
                    [formControl]="
                        bulkFormGroup.controls['Showcosttypesummary']
                    "
                    [indeterminate]="checkboxStates['Showcosttypesummary']?.indeterminate"
                    (onChange)="onCheckboxChange('Showcosttypesummary', $event)"
                ></p-checkbox>
                <a
                    style="z-index: 1; padding-left: 0.5rem"
                    title="Click for more information"
                    href="https://www.efaactcentral.com/eFAACTUserManual/index.htm?context=540#displayCostTypeSummary"
                    target="_blank"
                    >Display Cost Type Summary</a
                >
                <!-- <label style="margin-top: .05vh" for="Showcosttypesummary">Display Cost Type Summary</label> -->
            </span>
            <!-- <a style="z-index: 1;" title="Click for more information" href="https://www.efaactcentral.com/eFAACTUserManual/index.htm?context=540#displayCostTypeSummary" target="_blank"><i class="pi pi-info-circle"></i></a> -->
        </div>
        <div style="display: flex; flex-direction: row; width: 100%">
            <span id="spnShowcosttypesummaryburden" style="width: 17vw">
                <p-checkbox binary="true"
                    id="Showcosttypesummaryburden"
                    [formControl]="
                        bulkFormGroup.controls['Showcosttypesummaryburden']
                    "
                    [indeterminate]="checkboxStates['Showcosttypesummaryburden']?.indeterminate"
                    (onChange)="onCheckboxChange('Showcosttypesummaryburden', $event)"
                ></p-checkbox>
                <a
                    style="z-index: 1; padding-left: 0.5rem"
                    title="Click for more information"
                    href="https://www.efaactcentral.com/eFAACTUserManual/index.htm?context=540#displaySeparateBurdenRows"
                    target="_blank"
                    >Display Separate Burden Rows</a
                >
                <!-- <label style="margin-top: .05vh" for="Showcosttypesummaryburden"
                    >Display Separate Burden Rows</label
                > -->
            </span>
            <!-- <a style="z-index: 1;" title="Click for more information" href="https://www.efaactcentral.com/eFAACTUserManual/index.htm?context=540#displaySeparateBurdenRows" target="_blank"><i class="pi pi-info-circle"></i></a> -->
        </div>

        <h2>Invoice Detail</h2>

        <div
            style="
                display: flex;
                flex-direction: row;
                width: 100%;
                margin-bottom: 1vh;
            "
        >
            <p-floatLabel variant="on" class="w-full">
                <p-select
                    id="Invoiceviewoptionid"
                    [options]="invoiceViewOptions"
                    formControlName="Invoiceviewoptionid"
                    [filter]="true"
                    appendTo="body"
                    [autoDisplayFirst]="false"
                    styleClass="w-full"
                >
                </p-select>
                <label for="Invoiceviewoptionid">Detail View</label>
            </p-floatLabel>
            <!-- <a style="z-index: 1; margin-top: .8vh; margin-left: .5vw;" title="Click for more information" href="https://www.efaactcentral.com/eFAACTUserManual/index.htm?context=540#detailView" target="_blank"><i class="pi pi-info-circle"></i></a> -->
        </div>

        <div
            style="
                display: flex;
                flex-direction: row;
                width: 100%;
                margin-bottom: 1vh;
            "
        >
            <span id="spnShowlaborrates" style="width: 17vw">
                <p-checkbox binary="true"
                    id="Showlaborrates"
                    [formControl]="bulkFormGroup.controls['Showlaborrates']"
                    [indeterminate]="checkboxStates['Showlaborrates']?.indeterminate"
                    (onChange)="onCheckboxChange('Showlaborrates', $event)"
                ></p-checkbox>
                <a
                    style="z-index: 1; padding-left: 0.5rem"
                    title="Click for more information"
                    href="https://www.efaactcentral.com/eFAACTUserManual/index.htm?context=540#showLaborRates"
                    target="_blank"
                    >Show Labor Rates (SI Price)</a
                >
                <!-- <label style="margin-top: .05vh" for="Showlaborrates">Show Labor Rates (SI Price)</label> -->
            </span>
            <!-- <a style="z-index: 1;" title="Click for more information" href="https://www.efaactcentral.com/eFAACTUserManual/index.htm?context=540#showLaborRates" target="_blank"><i class="pi pi-info-circle"></i></a> -->
        </div>
        <div
            style="
                display: flex;
                flex-direction: row;
                width: 100%;
                margin-bottom: 1vh;
            "
        >
            <span id="spnShowburdens" style="width: 15vw">
                <p-checkbox binary="true"
                    id="Showburdens"
                    [formControl]="bulkFormGroup.controls['Showburdens']"
                    [indeterminate]="checkboxStates['Showburdens']?.indeterminate"
                    (onChange)="onCheckboxChange('Showburdens', $event)"
                ></p-checkbox>
                <a
                    style="z-index: 1; padding-left: 0.5rem"
                    title="Click for more information"
                    href="https://www.efaactcentral.com/eFAACTUserManual/index.htm?context=540#showBurdens"
                    target="_blank"
                    >Show Burdens (by column)</a
                >
                <!-- <label style="margin-top: .05vh" for="Showburdens">Show Burdens (by column)</label> -->
            </span>
            <!-- <a style="z-index: 1;" title="Click for more information" href="https://www.efaactcentral.com/eFAACTUserManual/index.htm?context=540#showBurdens" target="_blank"><i class="pi pi-info-circle"></i></a> -->
        </div>
        <div style="display: flex; flex-direction: row; width: 100%">
            <span id="spnShowcurrentactivityonly" style="width: 20vw">
                <p-checkbox binary="true"
                    id="Showcurrentactivityonly"
                    [formControl]="
                        bulkFormGroup.controls['Showcurrentactivityonly']
                    "
                    [indeterminate]="checkboxStates['Showcurrentactivityonly']?.indeterminate"
                    (onChange)="onCheckboxChange('Showcurrentactivityonly', $event)"
                ></p-checkbox>
                <a
                    style="z-index: 1; padding-left: 0.5rem"
                    title="Click for more information"
                    href="https://www.efaactcentral.com/eFAACTUserManual/index.htm?context=540#showCurrentPeriodAmtsOnly"
                    target="_blank"
                    >Show Current Period Amts Only (> $0)</a
                >
                <!-- <label style="margin-top: .05vh" for="Showcurrentactivityonly"
                    >Show Current Period Amts Only (> $0)</label
                > -->
            </span>
            <!-- <a style="z-index: 1;" title="Click for more information" href="https://www.efaactcentral.com/eFAACTUserManual/index.htm?context=540#showCurrentPeriodAmtsOnly" target="_blank"><i class="pi pi-info-circle"></i></a> -->
        </div>

        <h2>Header and Footer</h2>
        <div
            style="
                display: flex;
                flex-direction: row;
                width: 100%;
                margin-bottom: 1vh;
            "
        >
            <span id="spnTaxpayerId" style="width: 13vw">
                <p-checkbox binary="true"
                    id="ShowEIN"
                    [formControl]="bulkFormGroup.controls['ShowEIN']"
                    #ShowEIN
                    [indeterminate]="checkboxStates['ShowEIN']?.indeterminate"
                    (onChange)="onCheckboxChange('ShowEIN', $event)"
                ></p-checkbox>
                <a
                    style="z-index: 1; padding-left: 0.5rem"
                    title="Click for more information"
                    href="https://www.efaactcentral.com/eFAACTUserManual/index.htm?context=540#showTaxpayerID"
                    target="_blank"
                    >Show Taxpayer ID</a
                >
                <!-- <label style="margin-top: .05vh" for="ShowEIN">Show Taxpayer ID</label> -->
            </span>
            <!-- <a style="z-index: 1;" title="Click for more information" href="https://www.efaactcentral.com/eFAACTUserManual/index.htm?context=540#showTaxpayerID" target="_blank"><i class="pi pi-info-circle"></i></a> -->
        </div>

        <div
            style="
                display: flex;
                flex-direction: row;
                width: 100%;
                margin-bottom: 1vh;
            "
        >
            <p-floatLabel variant="on" class="w-full">
                <p-select
                    id="Remitaddrid"
                    [options]="addresses"
                    formControlName="Remitaddrid"
                    [filter]="true"
                    appendTo="body"
                    [autoDisplayFirst]="false"
                    styleClass="w-full"
                >
                </p-select>
                <label for="Remitaddrid">Remit To</label>
            </p-floatLabel>
            <!-- <a style="z-index: 1; margin-top: .8vh; margin-left: .5vw;" title="Click for more information" href="https://www.efaactcentral.com/eFAACTUserManual/index.htm?context=540#remitTo" target="_blank"><i class="pi pi-info-circle"></i></a> -->
        </div>

        <div
            style="
                display: flex;
                flex-direction: row;
                width: 100%;
                margin-bottom: 1vh;
            "
        >
            <p-floatLabel variant="on" class="w-full">
                <p-select
                    id="Billaddrid"
                    [options]="addresses"
                    formControlName="Billaddrid"
                    [filter]="true"
                    appendTo="body"
                    [autoDisplayFirst]="false"
                    styleClass="w-full"
                >
                </p-select>
                <label for="Billaddrid">Bill To</label>
            </p-floatLabel>
            <!-- <a style="z-index: 1; margin-top: .8vh; margin-left: .5vw;" title="Click for more information" href="https://www.efaactcentral.com/eFAACTUserManual/index.htm?context=540#billTo" target="_blank"><i class="pi pi-info-circle"></i></a> -->
        </div>

        <div
            style="
                display: flex;
                flex-direction: row;
                width: 100%;
                margin-bottom: 1vh;
            "
        >
            <p-floatLabel variant="on" class="w-full">
                <p-select
                    id="Siglineid"
                    [options]="signatureLineProperties"
                    formControlName="Siglineid"
                    [filter]="true"
                    appendTo="body"
                    [autoDisplayFirst]="false"
                    styleClass="w-full"
                >
                </p-select>
                <label for="Siglineid">Signature</label>
            </p-floatLabel>
            <!-- <a style="z-index: 1; margin-top: .8vh; margin-left: .5vw;" title="Click for more information" href="https://www.efaactcentral.com/eFAACTUserManual/index.htm?context=540#signature" target="_blank"><i class="pi pi-info-circle"></i></a> -->
        </div>

        <div
            style="
                display: flex;
                flex-direction: row;
                width: 100%;
                margin-bottom: 1vh;
            "
        >
            <p-floatLabel variant="on" class="w-full">
                <p-select
                    id="Disclaimerid"
                    [options]="disclaimerProperties"
                    formControlName="Disclaimerid"
                    [filter]="true"
                    appendTo="body"
                    [autoDisplayFirst]="false"
                    styleClass="w-full"
                >
                </p-select>
                <label for="Disclaimerid">Disclaimer</label>
            </p-floatLabel>
            <!-- <a style="z-index: 1; margin-top: .8vh; margin-left: .5vw;" title="Click for more information" href="https://www.efaactcentral.com/eFAACTUserManual/index.htm?context=540#disclaimer" target="_blank"><i class="pi pi-info-circle"></i></a> -->
        </div>
    </form>
    <ng-template #footer >
        <button
            pButton
            type="button"
            class="p-button-secondary"
            aria-label="Reset All Checkboxes"
            icon="pi pi-refresh"
            label="Reset Checkboxes"
            (click)="resetAllToIndeterminate()"
        ></button>
        <button
            pButton
            class="p-button-success"
            aria-label="Apply Bulk Updates"
            [disabled]="bulkFormGroup.pristine || bulkFormGroup.invalid"
            icon="pi pi-check"
            label="Update"
            (click)="dialogRef.close(bulkFormGroup.value)"
        ></button>
        <button
            pButton
            type="button"
            class="p-button-danger"
            aria-label="Cancel"
            icon="pi pi-times"
            label="Cancel"
            (click)="this.dialogRef.close()"
        ></button>
    </ng-template>
</p-dialog>
